<template>
  <div class="group-title">
      <div>
        <span class="group-title__content">{{title}}</span>
        <slot></slot>
      </div>
      <i @click="onClose" class="yxt-icon-close"></i>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      require: true
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.group-title{
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__content{
        font-size: 16px;
        font-weight: 500;
        color: #262626;
        line-height: 24px;
    }
    /deep/ .yxt-icon-close{
        cursor: pointer;
        padding: 5px;
    }
}
</style>>
